// extracted by mini-css-extract-plugin
export default {"about":"Instructors_about__FYC+1"};